module.exports = __webpack_public_path__ + "static/GE_Module_5-039863ab07fd22c01531a39c7b2355d7.png";